module.exports = __webpack_public_path__ + "img/20220812110043293bb9.14331bce.jpg";